import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from "./ThemeProvider";

const root = createRoot(document.getElementById('root'));
root.render(
  <>
  <ThemeProvider>
      <Router>
        <App />
      </Router>
    </ThemeProvider>
  </>
);

reportWebVitals(console.log);